import script from "./Test-Single-Quatation.vue?vue&type=script&setup=true&lang=js"
export * from "./Test-Single-Quatation.vue?vue&type=script&setup=true&lang=js"

import "./Test-Single-Quatation.vue?vue&type=style&index=0&id=38051c66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38051c66"]])

export default __exports__